import React from "react";
import Footer from "../components/Footer";
import grupo from "../images/grupo.jpg";
import transporte from "../images/transporte.png";
import localidad from "../images/tucuman.png";
import precio from "../images/SanPancracio.png";
import camion from "../images/camion.png";
import estacion from "../images/estacion.png";
import estado from "../images/estado.png";
import observa from "../images/observa.png";
import destino from "../images/destino.png";
import producto from "../images/papas.png";
import proveedor from "../images/proveedor.jpeg";
import chofer from "../images/avatarproveedor.png";
import egreso from "../images/egreso.png";
import lote from "../images/lote.jpeg";
import personal from "../images/personal.png";
import cuota from "../images/cuota.jpg";
import imputa from "../images/imputa.jpg";
import { Link } from "react-router-dom";
import "../css/homealtas.css";
import "../css/footer.css";

const items = [
  { to: "/clientes", img: grupo, label: "Clientes" },
  { to: "/proveedores", img: proveedor, label: "Proveedores" },
  { to: "/localidades", img: localidad, label: "Localidades" },
  { to: "/productos", img: producto, label: "Productos" },
  { to: "/estados", img: estado, label: "Estados" },
  { to: "/observas", img: observa, label: "Observaciones" },
  { to: "/transportes", img: transporte, label: "Transportes" },
  { to: "/empresas", img: precio, label: "Empresas" },
  { to: "/camiones", img: camion, label: "Vehiculos" },
  // { to: "/destinos", img: destino, label: "Destino" },
  { to: "/choferes", img: chofer, label: "Choferes" },
  { to: "/cuentagastos", img: egreso, label: "Cuenta de Gastos" },
  { to: "/gastos", img: egreso, label: "Gastos" },
  { to: "/imputas", img: imputa, label: "Imputaciones" },
  { to: "/lotes", img: lote, label: "Lotes" },
  { to: "/personas", img: personal, label: "Personas" },
  { to: "/metodos", img: cuota, label: "Metodos" },
  { to: "/estaciones", img: estacion, label: "Estación Servicio" },


];

const HomeAltas = () => (
  <>
    <div className="container mt-5">
      <hr />
      <div className="row text-center mb-3">
        <div className="col-12">
          <h1>Gestión de Altas</h1>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-6 d-flex flex-wrap justify-content-center gap-4">
          {items.map(({ to, img, label }) => (
            <div key={to} className="text-center">
              <Link to={to} className="text-decoration-none custom-link">
                <img
                  src={img}
                  alt={label}
                  className="img-fluid mb-2"
                style={{
                height: "70px",
                width: "70px",
                objectFit: "contain",
                backgroundColor: "#fff" // opcional si querés fondo blanco
          }}  
                />        
                <h3 className="h6 text-dark">{label}</h3>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>

    <Footer />
  </>
);

export default HomeAltas;
